import React from "react";

const NoiseOverlay = () => <div className="noise-overlay" aria-hidden="true" />;

export default NoiseOverlay;
